import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable()

export class SnackbarService {

  constructor(private snackbar: MatSnackBar) {
  }

  success(message: string, duration: number = 2000) {
    this.snackbar.open(message, 'Sluiten', {
      duration: duration,
      panelClass: ['snackbar-success'],
      horizontalPosition: 'left',
      verticalPosition: 'bottom'
    });
  }

  info(message: string, duration: number = 5000) {
    this.snackbar.open(message, 'Sluiten', {
      duration: duration,
      panelClass: ['snackbar-info'],
      horizontalPosition: 'left',
      verticalPosition: 'bottom'
    });
  }

  // noinspection JSUnusedGlobalSymbols
  warning(message: string, duration: number = 5000) {
    this.snackbar.open(message, 'Sluiten', {
      duration: duration,
      panelClass: ['snackbar-warning'],
      horizontalPosition: 'left',
      verticalPosition: 'bottom'
    });
  }

  error(message: string, duration: number = 5000) {
    this.danger(message, duration);
  }

  danger(message: string, duration: number = 5000) {
    this.snackbar.open(message, 'Sluiten', {
      duration: duration,
      panelClass: ['snackbar-error'],
      horizontalPosition: 'left',
      verticalPosition: 'bottom'
    });
  }
}
